import type { AiAppCenterModule } from '../types'

export const hotelModule: AiAppCenterModule = {
  key: 'hotel',
  label: 'AI智慧酒店',
  desc: '客房管理 / 预订系统 / 入住退房',
  path: '/hotel',
  homePath: '/hotel/dashboard',
  icon: 'ep:home-filled',
  color: '#8b5cf6'
}
